module.exports = __webpack_public_path__ + "img/desktop-catch-background.94178243.png";